@if (feedback(); as feedback) {
<!-- One branch per state: the hisImage directive appends the icon instead of replacing
         it, so the image key must not change on an existing element. -->
@switch (feedback.state) {
@case ('valid') {
<button type="button" hisImage="PASSED" class="transparent" [title]="feedback.iconTitle"
        (click)="panel.toggle($event)"></button>
}
@case ('validCpdf') {
<button type="button" hisImage="PASSED" class="transparent" [title]="feedback.iconTitle"
        (click)="panel.toggle($event)"></button>
}
@case ('revoked') {
<button type="button" hisImage="LIGHTNING" class="transparent" [title]="feedback.iconTitle"
        (click)="panel.toggle($event)"></button>
}
@case ('indeterminate') {
<button type="button" hisImage="WARNING" class="transparent" [title]="feedback.iconTitle"
        (click)="panel.toggle($event)"></button>
}
@case ('invalid') {
<button type="button" hisImage="ERROR" class="transparent" [title]="feedback.iconTitle"
        (click)="panel.toggle($event)"></button>
}
@case ('unsigned') {
<button type="button" hisImage="INFORMATION" class="transparent" [title]="feedback.iconTitle"
        (click)="panel.toggle($event)"></button>
}
@case ('unreadable') {
<button type="button" hisImage="WARNING" class="transparent" [title]="feedback.iconTitle"
        (click)="panel.toggle($event)"></button>
}
}
<p-overlayPanel #panel [showCloseIcon]="true" [dismissable]="true">
    <ng-template pTemplate>
        <div class="signedPdfResource signedPdfResource-stacked">
            <div [class]="feedback.styleClass">
                <!-- One branch per state: the hisImage directive appends the icon instead of
                         replacing it, so the image key must not change on an existing element. -->
                @switch (feedback.state) {
                @case ('valid') {
                <img hisImage="PASSED" class="statusIcon" [alt]="feedback.iconTitle" [title]="feedback.iconTitle">
                }
                @case ('validCpdf') {
                <img hisImage="PASSED" class="statusIcon" [alt]="feedback.iconTitle" [title]="feedback.iconTitle">
                }
                @case ('revoked') {
                <img hisImage="LIGHTNING" class="statusIcon" [alt]="feedback.iconTitle" [title]="feedback.iconTitle">
                }
                @case ('indeterminate') {
                <img hisImage="WARNING" class="statusIcon" [alt]="feedback.iconTitle" [title]="feedback.iconTitle">
                }
                @case ('invalid') {
                <img hisImage="ERROR" class="statusIcon" [alt]="feedback.iconTitle" [title]="feedback.iconTitle">
                }
                @case ('unsigned') {
                <img hisImage="INFORMATION" class="statusIcon" [alt]="feedback.iconTitle" [title]="feedback.iconTitle">
                }
                @case ('unreadable') {
                <img hisImage="WARNING" class="statusIcon" [alt]="feedback.iconTitle" [title]="feedback.iconTitle">
                }
                }
                <div [innerHTML]="feedback.text"></div>
            </div>
        </div>
    </ng-template>
</p-overlayPanel>
}